module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "content_title"
  }, [_vm._v("\n    " + _vm._s(_vm.catedetailDataArr.ldname) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content_date"
  }, [_vm._v("\n    发布日期：" + _vm._s(_vm._f("timeFormat")(_vm.catedetailDataArr.create_time)) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content_container"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["ldname"]) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("生日")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["age"]) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("性别")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["sex"]) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("身高")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["height"]) + " cm\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("体重")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["weight"]) + " kg\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("鞋码")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["shoesize"]) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("单位名称")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["danwei"]) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("城市")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["province"]) + "/\n        " + _vm._s(_vm.catedetailDataArr["city"]) + "/" + _vm._s(_vm.catedetailDataArr["county"]) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("可演出时间")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["yan_time"]) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("联系手机")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["phone"]) + "\n      ")])]), _vm._v(" "), (_vm.catedetailDataArr['caiyi']) ? _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("个人才艺")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_vm._v("\n        " + _vm._s(_vm.catedetailDataArr["caiyi"]) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.catedetailDataArr['content']) ? _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("个人经历")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value html-data html-data-person",
    domProps: {
      "innerHTML": _vm._s(_vm.catedetailDataArr['content'])
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.catedetailDataArr.pics && _vm.catedetailDataArr.pics.length) ? _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("艺术照")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_c('viewer', {
    attrs: {
      "images": _vm.catedetailDataArr.pics
    }
  }, _vm._l((_vm.catedetailDataArr.pics), function(item2, index2) {
    return _c('img', {
      key: index2,
      staticClass: "content_item_value_img",
      attrs: {
        "src": item2.url
      }
    })
  }), 0)], 1)]) : _vm._e(), _vm._v(" "), (_vm.catedetailDataArr['video'] && _vm.catedetailDataArr['video'].length) ? _c('div', {
    staticClass: "content_item"
  }, [_c('div', {
    staticClass: "content_item_name"
  }, [_vm._v("视频")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_value"
  }, [_c('div', {
    staticClass: "video_area"
  }, [_c('video', {
    ref: "myVideo",
    attrs: {
      "preload": "auto",
      "src": _vm.catedetailDataArr['video'][0].url,
      "controls": "controls"
    }
  })])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d41607c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/CuteSinglePage.vue
// module id = 1234
// module chunks = 0